<div class="survey-container">
  <div class="survey-container__header">
    <i (click)="onCloseSurvey()" class="icon-close icon-16"></i>
  </div>

  <span class="survey-container__title">{{ questionTitle }}</span>

  <div class="survey-container__icons">
    <i (click)="onDislike()" class="icon-ic-dislike-circle"></i>
    <i (click)="onLike()" class="icon-ic-like-circle"></i>
  </div>
</div>
